module.exports = __webpack_public_path__ + "img/help-support-inactive-icon.8a00d3c4.svg";